import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import LoyaltyProductLogo from 'loyalty/components/LoyaltyProductLogo'
import Badge from 'LuxKit/Badge'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCanRedeemLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import Clickable from 'components/Common/Clickable'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 ${rem(4)};
  transition: background-color 0.2s;
`

const LogoButton = styled(Clickable)`
  position: relative;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  text-decoration: none;
  flex-shrink: 0;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  display: flex;
  align-items: center;
  gap: ${rem(4)};
  height: ${rem(48)};
  padding: ${rem(8)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(8)} ${rem(24)};
  }

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        background-color: ${props => props.theme.palette.neutral.default.seven};
      }
    }

    &:focus {
      ${interactiveFocusStyle}
    }

    &:active {
      background-color: ${props => props.theme.palette.neutral.default.six};
    }
  }
`

interface Props {
  isNew?: boolean
  variant: 'luxPlus' | 'loyalty'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

function NavBarHamburgerMenuLoyaltyItem(props: Props) {
  const { variant, isNew, onClick } = props
  const intl = useIntl()

  const isLuxPlusMember = useAppSelector(state => getCanRedeemLuxPlusBenefits(state))

  const luxPlusJoinText = intl.formatMessage({
    id: 'eZRqbKYTj9',
    defaultMessage: 'Join our VIP Travel Club',
    description: 'Text shown for non-members to join Lux Plus',
  })

  const luxPlusMemberText = intl.formatMessage({
    id: 'bGPVGRdDtz',
    defaultMessage: 'VIP Travel Club',
    description: 'Text shown for Lux Plus members',
  })

  const loyaltyText = intl.formatMessage({
    id: 'TKQ5WXCkZX',
    defaultMessage: 'Earn points with',
    description: 'Text shown for loyalty program',
  })

  const newBadgeText = intl.formatMessage({
    id: 'rrVj8Awca9',
    defaultMessage: 'New',
    description: 'New badge text',
  })

  return <LogoButton
    onClick={onClick}
    to={variant === 'luxPlus' ? '/lux-plus' : `/${LOYALTY_LANDING_PAGE}`}
  >
    <Group direction="horizontal" gap={4} verticalAlign="center">
      <BodyText variant="small" colour="neutral-three">
        {variant === 'luxPlus' && (!isLuxPlusMember ? luxPlusJoinText : luxPlusMemberText)}
        {variant === 'loyalty' && loyaltyText}
      </BodyText>
      <Logo>
        {variant === 'luxPlus' && <LuxPlusLogo height={12} />}
        {variant === 'loyalty' && <LoyaltyProductLogo height={19} />}
      </Logo>
    </Group>
    {isNew && <Badge mode="critical" kind="string">{newBadgeText}</Badge>}
  </LogoButton>
}

export default NavBarHamburgerMenuLoyaltyItem
